import React, {Fragment} from 'react'
import {ReactComponent as Logo} from '../assets/logo.svg'
import style from '../scss/components/Footer.module.scss'
import {Fade} from 'react-awesome-reveal'

const Footer = () => {
    return (
        <Fragment>
            <div className={style.Row}>
                <div className={style.Left}>
                    <Fade direction={'up'} triggerOnce={true}>
                        <Logo/>
                        <div className={style.Logo}>
                            <div className={style.Text}>
                                SalonSecrets
                            </div>
                            <div className={style.Subtext}>
                                Masterclass by SalonLife
                            </div>
                        </div>
                    </Fade>
                </div>
                <div className={style.Right}>
                    <Fade direction={'up'} triggerOnce={true}>
                        <div className={style.Copyright}>
                            Copyright 2015-{(new Date()).getFullYear()} © Beautiful Life OÜ
                        </div>
                        <div className={style.Links}>
                            <a href={'https://salon.life/terms-of-service/'} target={'_blank'} rel={'noreferrer'}>Terms
                                of
                                Service</a>
                            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                            <a href={'https://salon.life/privacy/'} target={'_blank'} rel={'noreferrer'}>Privacy
                                Policy</a>
                        </div>
                    </Fade>
                </div>
            </div>
            <Fragment>
                {/*<Fade bottom big>
                    <div className={style.FloatingButton}>
                        <Button inverted mobile16>Register to the FREE Masterclass</Button>
                    </div>
                </Fade>*/}
                <div className={style.FloatingSpacer}/>
            </Fragment>
        </Fragment>
    )
}

export default Footer
